"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.object.keys.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _inputNumberStepper = require("@citrus/input-number-stepper");
var _inputRadio = require("@citrus/input-radio");
var _inputSelect = require("@citrus/input-select");
var _inputTextfield = require("@citrus/input-textfield");
var _inputWysiwyg = require("@citrus/input-wysiwyg");
var _inputCheckbox = require("@citrus/input-checkbox");
var _sortable = require("@citrus/sortable");
var _inputSwitch = require("@citrus/input-switch");
var _flyout = require("@citrus/flyout");
var _questionBuilder = require("@pcty/question-builder");
var _uuid = _interopRequireDefault(require("uuid"));
var _replaceAt = _interopRequireDefault(require("@pcty/utils-commonjs/array/replaceAt"));
var _get = _interopRequireDefault(require("@pcty/utils-commonjs/object/get"));
var _isNullOrEmpty = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNullOrEmpty"));
var _isNotNullOrEmpty = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNotNullOrEmpty"));
var _PctyQuestionBuilderEdit = _interopRequireDefault(require("./PctyQuestionBuilder.Edit.QuestionOptions"));
var _PctyQuestionBuilder = require("./PctyQuestionBuilder.Constants");
var _PctyQuestionBuilder2 = require("./PctyQuestionBuilder.Common");
var _PctyQuestionBuilder3 = _interopRequireDefault(require("./PctyQuestionBuilder.Video"));
var _lodash = _interopRequireDefault(require("lodash.isequal"));
var _lodash2 = _interopRequireDefault(require("lodash.findindex"));
var _lodash3 = _interopRequireDefault(require("lodash.find"));
require("./index.css");
var _em, _span, _Sortable$Row, _label, _Radio$Item, _Radio$Item2, _label2;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } //import '@citrus/layout/css/scaffolding-flex.css';
var PctyQuestionBuilderEditQuestion = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PctyQuestionBuilderEditQuestion, _Component);
  var _super = _createSuper(PctyQuestionBuilderEditQuestion);
  function PctyQuestionBuilderEditQuestion(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PctyQuestionBuilderEditQuestion);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangeMultiQuestionListDisplay", function (selected) {
      var edit = _objectSpread({}, _this.state.edit);
      edit.displayOrder = selected;
      _this.setState({
        edit: edit
      });
      _this.props.onChange(edit);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangeQuestionTypeOnChange", function (selected, key) {
      if (!selected || (0, _isNullOrEmpty.default)(selected.value)) return;
      var typeId = parseInt(selected.value);
      var isCompatibleOptionsQuestionType = [_questionBuilder.QUESTION_TYPE.multipleChoice, _questionBuilder.QUESTION_TYPE.checkbox, _questionBuilder.QUESTION_TYPE.dropdownList].indexOf(typeId) >= 0;
      var defaults = (0, _PctyQuestionBuilder2.getDefaultQuestionSettings)(typeId, _this.state.edit.answerRequired, _this.state.edit.pageId);
      var options = isCompatibleOptionsQuestionType ? (0, _toConsumableArray2.default)(_this.state.edit.options) : (0, _toConsumableArray2.default)(defaults.options);
      var edit = _objectSpread(_objectSpread(_objectSpread({}, _this.state.edit), defaults), {}, {
        options: options,
        typeId: typeId,
        question: _this.state.edit.question,
        otherQuestion: _objectSpread({}, _this.state.edit.otherQuestion),
        id: _this.state.edit.id,
        key: _this.state.edit.key
      });
      _this.setState({
        edit: edit
      });
      _this.props.onChange(edit);
    });
    var _edit = _objectSpread({}, _this.props.edit);
    _this.state = {
      _mounted: false,
      edit: _edit,
      newCompetency: '',
      showScenario: false,
      rawScenarioContentState: (0, _isNullOrEmpty.default)(_edit.scenario) ? null : (0, _inputWysiwyg.fromHtml)(_edit.scenario),
      rawQuestionContentState: (0, _isNullOrEmpty.default)(_edit.question) ? null : (0, _inputWysiwyg.fromHtml)(_edit.question),
      rawTitleContentState: (0, _isNullOrEmpty.default)(_edit.title) ? null : (0, _inputWysiwyg.fromHtml)(_edit.title),
      rawParagraphContentState: (0, _isNullOrEmpty.default)(_edit.content) ? null : (0, _inputWysiwyg.fromHtml)(_edit.content),
      rawVideoContentState: (0, _isNullOrEmpty.default)(_edit.title) ? null : (0, _inputWysiwyg.fromHtml)(_edit.title),
      validationState: {
        answer: {
          valid: false,
          errorMessage: 'You must have text'
        },
        question: {
          valid: false,
          errorMessage: 'The Question field is required.'
        },
        otherOption: {
          valid: false,
          errorMessage: 'The Other Response Label field is required.'
        },
        targetSum: {
          valid: false,
          errorMessage: 'Target Sum must be greater than Maximum value.'
        },
        minMax: {
          valid: false,
          errorMessage: 'Maxiumum value must be greater than Minimum value.'
        },
        valid: true,
        showValidationState: false
      },
      modalOpen: false,
      isTooltipOpen: false
    };
    _this.onChangeQuestion = _this.onChangeQuestion.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeScenario = _this.onChangeScenario.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeTitle = _this.onChangeTitle.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeParagraph = _this.onChangeParagraph.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeVideoTitle = _this.onChangeVideoTitle.bind((0, _assertThisInitialized2.default)(_this));
    _this.onVideoDoneHandler = _this.onVideoDoneHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeAllowMultipleResponses = _this.onChangeAllowMultipleResponses.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeIncludeSectionHeading = _this.onChangeIncludeSectionHeading.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeAnswerRequired = _this.onChangeAnswerRequired.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeSortableStackRankCorrectOrder = _this.onChangeSortableStackRankCorrectOrder.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeTextFieldPlaceHolder = _this.onChangeTextFieldPlaceHolder.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeTextFieldRadio = _this.onChangeTextFieldRadio.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeMultiNumberStepper = _this.onChangeMultiNumberStepper.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeStarRatingNumberStepper = _this.onChangeStarRatingNumberStepper.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeQuestionTypeOnChange = _this.onChangeQuestionTypeOnChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeRatingMinimumLabel = _this.onChangeRatingMinimumLabel.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeRatingMaximumLabel = _this.onChangeRatingMaximumLabel.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeEnforceTargetSum = _this.onChangeEnforceTargetSum.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeTargetSumValue = _this.onChangeTargetSumValue.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeMaximumValue = _this.onChangeMaximumValue.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeMinimumValue = _this.onChangeMinimumValue.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeOptions = _this.onChangeOptions.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeAllowCommentsCheckbox = _this.onChangeAllowCommentsCheckbox.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeCommentsPlaceholder = _this.onChangeCommentsPlaceholder.bind((0, _assertThisInitialized2.default)(_this));
    _this.toggleTooltip = _this.toggleTooltip.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderToolTip = _this.renderToolTip.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderDrawerQuestionContent = {
      trueFalse: {
        render: function render() {
          return _this.renderTrueFalse();
        }
      },
      multipleChoice: {
        render: function render() {
          return _this.renderMultipleChoice();
        }
      },
      checkbox: {
        render: function render() {
          return _this.renderMultipleChoice();
        }
      },
      stackRank: {
        render: function render() {
          return _this.renderStackRank();
        }
      },
      title: {
        render: function render() {
          return _this.renderTitle();
        }
      },
      paragraph: {
        render: function render() {
          return _this.renderParagraph();
        }
      },
      video: {
        render: function render() {
          return _this.renderVideo();
        }
      },
      textField: {
        render: function render() {
          return _this.renderTextField();
        }
      },
      starRating: {
        render: function render() {
          return _this.renderStarRating();
        }
      },
      ratingScale: {
        render: function render() {
          return _this.renderRatingScale();
        }
      },
      multipleText: {
        render: function render() {
          return _this.renderMultipleText();
        }
      },
      constantSum: {
        render: function render() {
          return _this.renderConstantSum();
        }
      },
      dropdownList: {
        render: function render() {
          return _this.renderDropdownList();
        }
      }
    };
    return _this;
  }
  (0, _createClass2.default)(PctyQuestionBuilderEditQuestion, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var stateReturn = {};
      if (!(0, _lodash.default)(this.state.validationState, nextProps.validationState)) {
        stateReturn = _objectSpread(_objectSpread({}, stateReturn), {}, {
          validationState: nextProps.validationState
        });
      }
      if (!(0, _lodash.default)(this.state.edit, nextProps.edit)) {
        var scenario = (0, _get.default)(nextProps, 'edit.scenario');
        var edit = _objectSpread({}, nextProps.edit);
        stateReturn = _objectSpread(_objectSpread({}, stateReturn), {}, {
          edit: edit,
          showScenario: !!scenario,
          rawScenarioContentState: !!scenario ? (0, _inputWysiwyg.fromHtml)(scenario) : null
        });
      }
      this.setState(_objectSpread({}, stateReturn));
    }
  }, {
    key: "onChangeScenario",
    value: function onChangeScenario(rawScenarioContentState) {
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        scenario: (0, _inputWysiwyg.toHtml)(rawScenarioContentState)
      });
      this.setState({
        rawScenarioContentState: rawScenarioContentState,
        edit: edit
      });
      return this.props.onChange(edit);
    }
  }, {
    key: "onChangeSortableStackRankCorrectOrder",
    value: function onChangeSortableStackRankCorrectOrder(items) {
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        answers: items ? items.map(function (x) {
          return {
            optionId: x.optionId
          };
        }) : []
      });
      this.setState({
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeOption",
    value: function onChangeOption(id, value) {
      var _id = id.replace("".concat(this.props.id, "-text-"), '');
      var index = (0, _lodash2.default)(this.state.edit.options, function (x) {
        return x.id === _id;
      });
      var correctOrderIndex = -1;
      var updated = _objectSpread(_objectSpread({}, this.state.edit.options[index]), {}, {
        value: value
      });
      if (this.props.builderType !== _PctyQuestionBuilder.BUILDER_TYPE.survey && this.state.edit.typeId === _questionBuilder.QUESTION_TYPE.stackRank) {
        correctOrderIndex = (0, _lodash2.default)(this.state.edit.answers, function (x) {
          return x.id === _id;
        });
      }
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        options: (0, _replaceAt.default)(this.state.edit.options, index, updated)
      });
      if (correctOrderIndex >= 0 && this.state.edit.answers) {
        edit = _objectSpread(_objectSpread({}, edit), {}, {
          answers: (0, _replaceAt.default)(this.state.edit.answers, correctOrderIndex, _objectSpread({}, updated))
        });
      }
      this.setState({
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeAllowMultipleResponses",
    value: function onChangeAllowMultipleResponses() {
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        typeId: this.state.edit.typeId === _questionBuilder.QUESTION_TYPE.checkbox ? _questionBuilder.QUESTION_TYPE.multipleChoice : _questionBuilder.QUESTION_TYPE.checkbox,
        options: this.state.edit.options.map(function (x) {
          return _objectSpread(_objectSpread({}, x), {}, {
            selected: false
          });
        }),
        answers: []
      });
      this.setState({
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeAnswerRequired",
    value: function onChangeAnswerRequired(req) {
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        answerRequired: req
      });
      this.setState({
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeIncludeSectionHeading",
    value: function onChangeIncludeSectionHeading(req) {
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        includeSectionHeading: req
      });
      this.setState({
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeRatingMinimumLabel",
    value: function onChangeRatingMinimumLabel(_ref) {
      var id = _ref.id,
        value = _ref.value;
      var edit = _objectSpread({}, this.state.edit);
      edit.minimumRateLabel = value;
      this.setState({
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeRatingMaximumLabel",
    value: function onChangeRatingMaximumLabel(_ref2) {
      var id = _ref2.id,
        value = _ref2.value;
      var edit = _objectSpread({}, this.state.edit);
      edit.maximumRateLabel = value;
      this.setState({
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeEnforceTargetSum",
    value: function onChangeEnforceTargetSum(req) {
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        enforceTargetSum: req
      });
      this.setState({
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeTargetSumValue",
    value: function onChangeTargetSumValue(_ref3) {
      var id = _ref3.id,
        value = _ref3.value;
      var edit = _objectSpread({}, this.state.edit);
      edit.targetSumValue = value;
      this.setState({
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeMaximumValue",
    value: function onChangeMaximumValue(_ref4) {
      var id = _ref4.id,
        value = _ref4.value;
      var edit = _objectSpread({}, this.state.edit);
      edit.maximumValue = value;
      this.setState({
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeMinimumValue",
    value: function onChangeMinimumValue(_ref5) {
      var id = _ref5.id,
        value = _ref5.value;
      var edit = _objectSpread({}, this.state.edit);
      edit.minimumValue = value;
      this.setState({
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeQuestion",
    value: function onChangeQuestion(value) {
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        question: (0, _inputWysiwyg.toHtml)(value)
      });
      this.setState({
        rawQuestionContentState: value,
        edit: edit
      });
      var validationState = (0, _PctyQuestionBuilder2.validate)(edit, this.state.validationState.showValidationState, this.props.builderType);
      this.props.onChange(edit, validationState);
    }
  }, {
    key: "onChangeTitle",
    value: function onChangeTitle(rawTitleContentState) {
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        title: (0, _inputWysiwyg.toHtml)(rawTitleContentState)
      });
      this.setState({
        rawTitleContentState: rawTitleContentState,
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeParagraph",
    value: function onChangeParagraph(rawParagraphContentState) {
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        content: (0, _inputWysiwyg.toHtml)(rawParagraphContentState)
      });
      this.setState({
        rawParagraphContentState: rawParagraphContentState,
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeVideoTitle",
    value: function onChangeVideoTitle(id, updates) {
      var updatedTitle = updates.hasOwnProperty('questionText') ? (0, _PctyQuestionBuilder2.decodeText)(updates.questionText) : (0, _PctyQuestionBuilder2.decodeText)(this.state.edit.title);
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        title: updatedTitle
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onVideoDoneHandler",
    value: function onVideoDoneHandler(item, videoEvent) {
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        videoId: videoEvent.videoId,
        filename: videoEvent.filename,
        videoInsertMethod: videoEvent.method,
        token: videoEvent.token,
        key: (0, _isNullOrEmpty.default)(videoEvent.videoId) ? _uuid.default.v4() : this.state.edit.key
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeTextFieldPlaceHolder",
    value: function onChangeTextFieldPlaceHolder(_ref6) {
      var id = _ref6.id,
        value = _ref6.value;
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        questionPlaceholder: value
      });
      this.setState({
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeMultiNumberStepper",
    value: function onChangeMultiNumberStepper(_ref7) {
      var id = _ref7.id,
        value = _ref7.value;
      var edit = _objectSpread({}, this.state.edit);
      edit.displayFormat = value > 0 ? value : 1;
      this.setState({
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeStarRatingNumberStepper",
    value: function onChangeStarRatingNumberStepper(_ref8) {
      var id = _ref8.id,
        value = _ref8.value;
      var edit = _objectSpread({}, this.state.edit);
      edit.starCount = value > 0 ? value : 1;
      this.setState({
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeTextFieldRadio",
    value: function onChangeTextFieldRadio(_ref9) {
      var groupId = _ref9.groupId,
        index = _ref9.index,
        value = _ref9.value;
      var multiLine = value === 'textarea';
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        multiLine: multiLine
      });
      this.setState({
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeOptions",
    value: function onChangeOptions(newEdit) {
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        options: newEdit.options ? (0, _toConsumableArray2.default)(newEdit.options) : [],
        answers: newEdit.answers ? (0, _toConsumableArray2.default)(newEdit.answers) : [],
        otherQuestion: _objectSpread({}, newEdit.otherQuestion)
      });
      this.setState({
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeAllowCommentsCheckbox",
    value: function onChangeAllowCommentsCheckbox(_ref10) {
      var id = _ref10.id,
        selected = _ref10.selected;
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        allowComments: selected
      });
      this.setState({
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "onChangeCommentsPlaceholder",
    value: function onChangeCommentsPlaceholder(_ref11) {
      var id = _ref11.id,
        value = _ref11.value;
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        commentsPlaceholder: value
      });
      this.setState({
        edit: edit
      });
      this.props.onChange(edit);
    }
  }, {
    key: "toggleTooltip",
    value: function toggleTooltip() {
      this.setState({
        isTooltipOpen: !this.state.isTooltipOpen
      });
    }
  }, {
    key: "renderTrueFalse",
    value: function renderTrueFalse() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.getScenario(), this.getQuestionTextbox(), this.getSortableOptions());
    }
  }, {
    key: "renderMultipleChoice",
    value: function renderMultipleChoice() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.getQuestionTypeRequired('Multiple Choice'), this.getScenario(), this.getQuestionTextbox(), this.getSortableOptions(), this.getMultipleChoiceSubRow());
    }
  }, {
    key: "renderStackRank",
    value: function renderStackRank() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.getQuestionTypeRequired('Stack Rank'), this.getScenario(), this.getQuestionTextbox(), this.getSortableOptions(), this.getStackRankSubRow());
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.getQuestionTypeRequired('Section Divider'), this.getSectionTitle());
    }
  }, {
    key: "renderParagraph",
    value: function renderParagraph() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.getQuestionTypeRequired('Paragraph'), this.getParagraph());
    }
  }, {
    key: "renderVideo",
    value: function renderVideo() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.getQuestionTypeRequired('Video'), this.getVideoContent());
    }
  }, {
    key: "renderTextField",
    value: function renderTextField() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.getQuestionTypeRequired('Text Field'), this.getQuestionTextbox(), this.getTextFieldSubRow());
    }
  }, {
    key: "renderStarRating",
    value: function renderStarRating() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.getQuestionTypeRequired('Star Rating'), this.getQuestionTextbox(), this.getStarRatingSubRow(), this.getCommentsSubRow());
    }
  }, {
    key: "renderRatingScale",
    value: function renderRatingScale() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.getQuestionTypeRequired('Rating Scale'), this.getQuestionTextbox(), this.getSortableOptions(), this.getRatingScaleMinMaxSubRow(), this.getCommentsSubRow());
    }
  }, {
    key: "renderMultipleText",
    value: function renderMultipleText() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.getQuestionTypeRequired('Multiple Text'), this.getQuestionTextbox(), this.getSortableOptions(), this.getMultipleTextSubRow());
    }
  }, {
    key: "renderConstantSum",
    value: function renderConstantSum() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.getQuestionTypeRequired('Constant Sum'), this.getQuestionTextbox(), this.getSortableOptions(), this.getConstantSumSubRow());
    }
  }, {
    key: "renderDropdownList",
    value: function renderDropdownList() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.getQuestionTypeRequired('Dropdown'), this.getScenario(), this.getQuestionTextbox(), this.getSortableOptions(), this.getDropdownListSubRow());
    }
  }, {
    key: "renderToolTip",
    value: function renderToolTip() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _em || (_em = /*#__PURE__*/_react.default.createElement("em", null, "(optional)")), /*#__PURE__*/_react.default.createElement("a", {
        "aria-label": "more information",
        "data-pcty-flyout-id": "scenario-flyout",
        onClick: this.toggleTooltip,
        title: "More Information"
      }, _span || (_span = /*#__PURE__*/_react.default.createElement("span", {
        className: "pcty-input-info-icon"
      }))));
    }
  }, {
    key: "getSortableOptions",
    value: function getSortableOptions() {
      var maximumItemCount = this.state.edit.typeId === _questionBuilder.QUESTION_TYPE.ratingScale ? _PctyQuestionBuilder.MAXIMUM_RATING_SCALE_ITEMS : 0;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-padding-bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilderEdit.default, {
        id: this.props.id,
        builderType: this.props.builderType,
        edit: this.state.edit,
        maximumItemCount: maximumItemCount,
        onOptionsChange: this.onChangeOptions,
        validationState: this.state.validationState,
        showValidationState: this.state.showValidationState
      })));
    }
  }, {
    key: "getStackRankSubRow",
    value: function getStackRankSubRow() {
      var _this2 = this;
      if (this.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey) return null;
      var renderHeader = function renderHeader() {
        return _Sortable$Row || (_Sortable$Row = /*#__PURE__*/_react.default.createElement(_sortable.Sortable.Row, null, /*#__PURE__*/_react.default.createElement(_sortable.Sortable.Column, null, "Correct Order")));
      };
      var renderItem = function renderItem(answer) {
        var option = (0, _lodash3.default)(_this2.state.edit.options, function (z) {
          return z.id === answer.optionId;
        });
        var display = option || {
          value: ''
        };
        return /*#__PURE__*/_react.default.createElement(_sortable.Sortable.Row, null, /*#__PURE__*/_react.default.createElement(_sortable.Sortable.Column, null, display.value));
      };
      var data = this.state.edit.answers.map(function (x) {
        return _objectSpread(_objectSpread({}, x), {}, {
          id: x.optionId
        });
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-padding-vertical"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, /*#__PURE__*/_react.default.createElement(_sortable.Sortable, {
        data: data,
        id: "".concat(this.props.id, "-").concat(this.state.edit.id, "-options-correct-order"),
        onChange: this.onChangeSortableStackRankCorrectOrder,
        renderHeader: renderHeader,
        renderItem: renderItem
      })));
    }
  }, {
    key: "getSectionTitle",
    value: function getSectionTitle() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-padding-bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-6"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-input-wrapper"
      }, _label || (_label = /*#__PURE__*/_react.default.createElement("label", {
        className: "pcty-input-label"
      }, "Include Section Heading")), /*#__PURE__*/_react.default.createElement(_inputSwitch.Switch, {
        id: "".concat(this.props.id, "-include-section-heading"),
        toggledOn: this.state.edit.includeSectionHeading,
        onChange: this.onChangeIncludeSectionHeading,
        textOff: "No",
        textOn: "Yes"
      })))), this.state.edit.includeSectionHeading && /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-padding-bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, /*#__PURE__*/_react.default.createElement(_inputWysiwyg.Wysiwyg, {
        id: "".concat(this.props.id, "-").concat(_questionBuilder.QUESTION_TYPE[this.state.edit.typeId]),
        key: this.state.edit.id,
        label: "Section Heading",
        onChange: this.onChangeTitle,
        placeholder: "Please enter your text",
        rawContentState: this.state.rawTitleContentState,
        toolbar: ['bold', 'italic', 'underline', 'unordered-list', 'ordered-list', 'undo', 'redo']
      }))));
    }
  }, {
    key: "getParagraph",
    value: function getParagraph() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-padding-vertical"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, /*#__PURE__*/_react.default.createElement(_inputWysiwyg.Wysiwyg, {
        id: "".concat(this.props.id, "-").concat(_questionBuilder.QUESTION_TYPE[this.state.edit.typeId]),
        key: this.state.edit.id,
        label: "Paragraph",
        required: true,
        style: {
          minHeight: '250px'
        },
        onChange: this.onChangeParagraph,
        placeholder: "Please enter your text",
        rawContentState: this.state.rawParagraphContentState,
        toolbar: ['bold', 'italic', 'underline', 'unordered-list', 'ordered-list', 'undo', 'redo']
      })));
    }
  }, {
    key: "getVideoContent",
    value: function getVideoContent() {
      var _this3 = this;
      //
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-padding-vertical"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilder3.default, {
        automationId: "".concat(this.props.id, "-video-").concat(this.state.edit.id.toString()),
        id: "".concat(this.props.id, "-video-").concat(this.state.edit.id.toString()),
        builderType: this.props.builderType,
        content: this.state.edit.title,
        videoId: this.state.edit.videoId,
        key: this.state.edit.key,
        editable: true,
        drawerMode: true,
        onQuestionUpdated: function onQuestionUpdated(updates) {
          return _this3.onChangeVideoTitle(_this3.state.edit.id, updates);
        },
        onGetSingleManageVideoToken: function onGetSingleManageVideoToken(videoId) {
          return _this3.props.onGetSingleManageVideoToken(videoId);
        },
        onVideoDoneHandler: function onVideoDoneHandler(videoEvent) {
          return _this3.onVideoDoneHandler(_this3.state.edit, videoEvent);
        },
        videoStudioEnabled: this.props.videoStudioEnabled
      })));
    }
  }, {
    key: "getTextFieldSubRow",
    value: function getTextFieldSubRow() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-margin-top pcty-padding-bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-6"
      }, /*#__PURE__*/_react.default.createElement(_inputRadio.Radio, {
        automationId: "".concat(this.props.id, "-radio-").concat(this.state.edit.id.toString()),
        id: "".concat(this.props.id, "-radio-").concat(this.state.edit.id.toString()),
        label: "Text Input Size",
        onChange: this.onChangeTextFieldRadio,
        selectedIndex: this.state.edit.multiLine ? 1 : 0,
        style: {
          flexDirection: 'column',
          alignItems: 'flex-start'
        }
      }, _Radio$Item || (_Radio$Item = /*#__PURE__*/_react.default.createElement(_inputRadio.Radio.Item, {
        automationId: "textfield",
        value: "textfield"
      }, "Single-line")), _Radio$Item2 || (_Radio$Item2 = /*#__PURE__*/_react.default.createElement(_inputRadio.Radio.Item, {
        automationId: "textarea",
        value: "textarea"
      }, "Multi-line")))), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-6"
      }, /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
        className: "pcty-question-builder-option-no-answer",
        id: "".concat(this.props.id, "-placeholder-text-").concat(this.state.edit.id.toString()),
        label: "Placeholder Text",
        maxLength: 500,
        onChange: this.onChangeTextFieldPlaceHolder,
        value: this.state.edit.questionPlaceholder
      })));
    }
  }, {
    key: "getStarRatingSubRow",
    value: function getStarRatingSubRow() {
      var min = 2;
      var max = 10;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-margin-top pcty-padding-bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-4"
      }, /*#__PURE__*/_react.default.createElement(_inputNumberStepper.NumberStepper, {
        footnote: "Minimum: ".concat(min, ". Maximum: ").concat(max, "."),
        formatter: function formatter(x) {
          if ((0, _isNotNullOrEmpty.default)(x) && parseInt(Math.floor(x)) > 0) {
            return x.toString().split('').reduce(function (aggregator, item, index) {
              return aggregator + item;
            }, '') + ' stars';
          }
          return '';
        },
        id: "star-rating",
        label: "Star Rating Scale",
        max: max,
        min: min,
        onChange: this.onChangeStarRatingNumberStepper,
        value: this.state.edit.starCount || 5
      })));
    }
  }, {
    key: "getRatingScaleMinMaxSubRow",
    value: function getRatingScaleMinMaxSubRow() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-margin-top pcty-padding-bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-6"
      }, /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
        className: "pcty-question-builder-rating-label",
        id: "".concat(this.props.id, "-rating-label-minimum-").concat(this.state.edit.id.toString()),
        label: "Minimum Rating Label",
        maxLength: 50,
        onChange: this.onChangeRatingMinimumLabel,
        value: this.state.edit.minimumRateLabel
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-6"
      }, /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
        className: "pcty-question-builder-rating-label",
        id: "".concat(this.props.id, "-rating-label-maximum-").concat(this.state.edit.id.toString()),
        label: "Maximum Rating Label",
        maxLength: 50,
        onChange: this.onChangeRatingMaximumLabel,
        value: this.state.edit.maximumRateLabel
      }))));
    }
  }, {
    key: "getScenario",
    value: function getScenario() {
      if (!this.props.includeScenario) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-padding-vertical"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, /*#__PURE__*/_react.default.createElement(_inputWysiwyg.Wysiwyg, {
        id: "".concat(this.props.id, "-scenario"),
        key: this.state.edit.id,
        label: "Scenario ",
        labelAddOn: this.renderToolTip,
        onChange: this.onChangeScenario,
        placeholder: "A scenario is text that sets up your question to give it a deeper context.",
        rawContentState: this.state.rawScenarioContentState,
        toolbar: ['bold', 'italic', 'underline', 'unordered-list', 'ordered-list', 'undo', 'redo']
      }), /*#__PURE__*/_react.default.createElement(_flyout.Flyout, {
        id: "scenario-flyout",
        isOpen: this.state.isTooltipOpen,
        location: "top",
        onClose: this.toggleTooltip
      }, "Scenarios are short or long stories that can provide relevant context to a quiz question. They can help learners think more deeply about a question instead of simply testing fact recall.")));
    }
  }, {
    key: "getQuestionTextbox",
    value: function getQuestionTextbox() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-padding-bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, /*#__PURE__*/_react.default.createElement(_inputWysiwyg.Wysiwyg, {
        errorMessage: this.state.validationState.question.errorMessage,
        id: "".concat(this.props.id, "-text"),
        key: this.state.edit.id,
        label: 'Question',
        required: true,
        maxLength: 1000,
        style: {
          minHeight: '150px'
        },
        placeholder: "Enter question text",
        onChange: this.onChangeQuestion,
        rawContentState: this.state.rawQuestionContentState,
        showValidationState: this.state.validationState.showValidationState,
        toolbar: ['bold', 'italic', 'underline', 'unordered-list', 'ordered-list', 'undo', 'redo'],
        valid: this.state.validationState.question.valid
      })));
    }
  }, {
    key: "getCommentsSubRow",
    value: function getCommentsSubRow() {
      return this.props.questionCommentsEnabled && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12 pcty-float-left pcty-padding-right-none"
      }, /*#__PURE__*/_react.default.createElement(_inputCheckbox.Checkbox, {
        automationId: "".concat(this.props.id, "-allow-comments-").concat(this.state.edit.id.toString()),
        id: "".concat(this.props.id, "-allow-comments-").concat(this.state.edit.id.toString()),
        onChange: this.onChangeAllowCommentsCheckbox,
        selected: this.state.edit.allowComments || false
      }, "Allow Comments"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-padding-bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
        disabled: !this.state.edit.allowComments,
        id: "".concat(this.props.id, "-comment-placeholder-").concat(this.state.edit.id.toString()),
        label: "Placeholder Text",
        maxLength: 500,
        onChange: this.onChangeCommentsPlaceholder,
        value: this.state.edit.commentsPlaceholder
      }))));
    }
  }, {
    key: "getQuestionTypeRequired",
    value: function getQuestionTypeRequired(questionTypeLabel) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-padding-bottom"
      }, this.getQuestionType(questionTypeLabel), this.getRequiredToggle(), this.getAllowMultipleResponsesBlock());
    }
  }, {
    key: "getRequiredToggle",
    value: function getRequiredToggle() {
      var _this4 = this;
      if (this.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.quiz || [_questionBuilder.QUESTION_TYPE.title, _questionBuilder.QUESTION_TYPE.paragraph, _questionBuilder.QUESTION_TYPE.video].indexOf(this.state.edit.typeId) > -1) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-3"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-input-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_inputSwitch.Switch, {
        id: "".concat(this.props.id, "-answer-required"),
        toggledOn: this.state.edit.answerRequired,
        onChange: function onChange(e) {
          return _this4.onChangeAnswerRequired(e.isOn);
        },
        label: "Require an Answer",
        hideOptionalLabel: true,
        textOff: "No",
        textOn: "Yes"
      })));
    }
  }, {
    key: "getAllowMultipleResponsesBlock",
    value: function getAllowMultipleResponsesBlock() {
      if ([_questionBuilder.QUESTION_TYPE.multipleChoice, _questionBuilder.QUESTION_TYPE.checkbox].indexOf(this.state.edit.typeId) <= -1) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-4"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-input-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_inputSwitch.Switch, {
        id: "".concat(this.props.id, "-multiple-responses"),
        toggledOn: this.state.edit.typeId === _questionBuilder.QUESTION_TYPE.checkbox,
        onChange: this.onChangeAllowMultipleResponses,
        textOff: "No",
        textOn: "Yes",
        label: "Allow Multiple Responses",
        hideOptionalLabel: true
      })));
    }
  }, {
    key: "getQuestionType",
    value: function getQuestionType(questionTypeLabel) {
      var _this5 = this;
      var isChangeableQuestionType = [_questionBuilder.QUESTION_TYPE.multipleChoice, _questionBuilder.QUESTION_TYPE.checkbox, _questionBuilder.QUESTION_TYPE.dropdownList, _questionBuilder.QUESTION_TYPE.starRating, _questionBuilder.QUESTION_TYPE.ratingScale].indexOf(this.state.edit.typeId) >= 0;
      var isContentQuestionType = [_questionBuilder.QUESTION_TYPE.title, _questionBuilder.QUESTION_TYPE.paragraph, _questionBuilder.QUESTION_TYPE.video].indexOf(this.state.edit.typeId) >= 0;
      var headerLabel = isContentQuestionType ? 'Content Type' : 'Question Type';
      if (this.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.quiz || !isChangeableQuestionType) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "pcty-col-xs-4 pcty-type-leftalign",
          style: {
            float: 'left'
          }
        }, /*#__PURE__*/_react.default.createElement("label", {
          className: "pcty-input-label"
        }, headerLabel), /*#__PURE__*/_react.default.createElement("p", null, questionTypeLabel));
      }
      var options = [];
      var defaultOption = {};
      var value = null;
      if (this.state.edit.typeId === _questionBuilder.QUESTION_TYPE.multipleChoice || this.state.edit.typeId === _questionBuilder.QUESTION_TYPE.checkbox) {
        options = [{
          value: _questionBuilder.QUESTION_TYPE.multipleChoice.toString(),
          label: 'Multiple Choice'
        }, {
          value: _questionBuilder.QUESTION_TYPE.dropdownList.toString(),
          label: 'Dropdown'
        }];
        defaultOption = {
          value: _questionBuilder.QUESTION_TYPE.multipleChoice.toString(),
          label: 'Multiple Choice'
        };
      } else if (this.state.edit.typeId === _questionBuilder.QUESTION_TYPE.dropdownList) {
        options = [{
          value: _questionBuilder.QUESTION_TYPE.multipleChoice.toString(),
          label: 'Multiple Choice'
        }, {
          value: _questionBuilder.QUESTION_TYPE.dropdownList.toString(),
          label: 'Dropdown'
        }];
        defaultOption = {
          value: _questionBuilder.QUESTION_TYPE.dropdownList.toString(),
          label: 'Dropdown'
        };
      } else if (this.state.edit.typeId === _questionBuilder.QUESTION_TYPE.starRating) {
        options = [{
          value: _questionBuilder.QUESTION_TYPE.starRating.toString(),
          label: 'Star Rating'
        }, {
          value: _questionBuilder.QUESTION_TYPE.ratingScale.toString(),
          label: 'Rating Scale'
        }];
        defaultOption = {
          value: _questionBuilder.QUESTION_TYPE.starRating.toString(),
          label: 'Star Rating'
        };
      } else if (this.state.edit.typeId === _questionBuilder.QUESTION_TYPE.ratingScale) {
        options = [{
          value: _questionBuilder.QUESTION_TYPE.starRating.toString(),
          label: 'Star Rating'
        }, {
          value: _questionBuilder.QUESTION_TYPE.ratingScale.toString(),
          label: 'Rating Scale'
        }];
        defaultOption = {
          value: _questionBuilder.QUESTION_TYPE.ratingScale.toString(),
          label: 'Rating Scale'
        };
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-4 pcty-type-leftalign",
        style: {
          float: 'left'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-input-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_inputSelect.SelectStatic, {
        automationId: "basic-input",
        id: "question-type-input",
        key: "questionTypeInput",
        label: "Question Type",
        onChange: function onChange(selected) {
          return _this5.onChangeQuestionTypeOnChange(selected, 'questionType');
        },
        options: options,
        className: "question-type-input",
        value: this.state.questionType || defaultOption
      })));
    }
  }, {
    key: "getMultipleChoiceSubRow",
    value: function getMultipleChoiceSubRow() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-padding-bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-6 pcty-type-leftalign",
        style: {
          float: 'left'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-input-wrapper"
      }, this.getListDisplayOrder())), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-6 pcty-type-leftalign",
        style: {
          float: 'left'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-input-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_inputNumberStepper.NumberStepper, {
        formatter: function formatter(x) {
          if ((0, _isNotNullOrEmpty.default)(x) && parseInt(Math.floor(x)) > 0) {
            return x.toString().split('').reduce(function (aggregator, item, index) {
              return aggregator + item;
            }, '') + " column".concat(parseInt(x) > 1 ? 's' : '');
          }
          return '';
        },
        id: "multi-columns",
        label: "List Display Format",
        min: 1,
        max: 10,
        onChange: this.onChangeMultiNumberStepper,
        value: this.state.edit.displayFormat
      }))));
    }
  }, {
    key: "getDropdownListSubRow",
    value: function getDropdownListSubRow() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-padding-bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-6 pcty-type-leftalign",
        style: {
          float: 'left'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-input-wrapper"
      }, this.getListDisplayOrder())), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-6 pcty-type-leftalign",
        style: {
          float: 'left'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-input-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
        className: "pcty-question-builder-option-no-answer",
        id: "".concat(this.props.id, "-default-text-").concat(this.state.edit.id.toString()),
        label: "Default Text for Dropdown",
        maxLength: 500,
        onChange: this.onChangeTextFieldPlaceHolder,
        value: this.state.edit.questionPlaceholder
      }))));
    }
  }, {
    key: "getListDisplayOrder",
    value: function getListDisplayOrder() {
      var listOptions = [{
        value: 'defined',
        label: 'As Defined'
      }, {
        value: 'ascending',
        label: 'Ascending'
      }, {
        value: 'descending',
        label: 'Descending'
      }, {
        value: 'random',
        label: 'Random'
      }];
      return /*#__PURE__*/_react.default.createElement(_inputSelect.SelectStatic, {
        automationId: "basic-input",
        id: "list-display-order",
        key: "basic",
        className: "list-display-order ",
        label: "List Display Order",
        onChange: this.onChangeMultiQuestionListDisplay,
        options: listOptions,
        placeholder: "Select an Item",
        value: this.state.edit.displayOrder
      });
    }
  }, {
    key: "getMultipleTextSubRow",
    value: function getMultipleTextSubRow() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-padding-bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-6 pcty-type-leftalign",
        style: {
          float: 'left'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-input-wrapper"
      }, this.getListDisplayOrder())));
    }
  }, {
    key: "getConstantSumSubRow",
    value: function getConstantSumSubRow() {
      var _this6 = this;
      var showTargetSumError = !this.state.validationState.targetSum.valid && this.state.validationState.showValidationState;
      var showMinMaxError = !this.state.validationState.minMax.valid && this.state.validationState.showValidationState;
      var cssTargetSum = showTargetSumError ? ' pcty-error' : '';
      var cssMinMax = showMinMaxError ? ' pcty-error' : '';
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-padding-bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-6 pcty-type-leftalign",
        style: {
          float: 'left'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-input-wrapper"
      }, _label2 || (_label2 = /*#__PURE__*/_react.default.createElement("label", {
        className: "pcty-input-label"
      }, "Enforce Target Sum")), /*#__PURE__*/_react.default.createElement(_inputSwitch.Switch, {
        footnote: "All answers must add up to the target sum",
        id: "".concat(this.props.id, "-enforce-targetsum"),
        toggledOn: this.state.edit.enforceTargetSum,
        onChange: function onChange(e) {
          return _this6.onChangeEnforceTargetSum(e.isOn);
        },
        textOff: "No",
        textOn: "Yes"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-6 pcty-type-leftalign",
        style: {
          float: 'left'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'pcty-input-wrapper' + cssTargetSum
      }, this.state.edit.enforceTargetSum && /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
        className: "pcty-question-builder-constantsum-targetsum",
        formatter: function formatter(x) {
          if ((0, _isNotNullOrEmpty.default)(x) && parseInt(Math.floor(x)) > 0) {
            return x.toString();
          }
          return '';
        },
        id: "".concat(this.props.id, "-constantsum-targetsum-").concat(this.state.edit.id.toString()),
        label: "Target Sum",
        maxLength: 5,
        onChange: this.onChangeTargetSumValue,
        placeholder: "Enter target sum value",
        required: this.state.edit.enforceTargetSum,
        value: this.state.edit.targetSumValue
      }), showTargetSumError ? /*#__PURE__*/_react.default.createElement("span", {
        className: "pcty-input-footnote pcty-input-validation pcty-error pcty-margin-compact-top"
      }, this.state.validationState.targetSum.errorMessage) : ''))), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-padding-bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-6 pcty-type-leftalign",
        style: {
          float: 'left'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'pcty-input-wrapper' + cssMinMax
      }, /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
        className: "pcty-question-builder-constantsum-minimum",
        footnote: "Minimum value of each input field",
        formatter: function formatter(x) {
          if ((0, _isNotNullOrEmpty.default)(x) && parseInt(Math.floor(x)) > 0) {
            return x.toString();
          }
          return '';
        },
        id: "".concat(this.props.id, "-constantsum-minimum-").concat(this.state.edit.id.toString()),
        label: "Minimum Value",
        maxLength: 5,
        onChange: this.onChangeMinimumValue,
        placeholder: "Enter minimum value",
        value: this.state.edit.minimumValue
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-6 pcty-type-leftalign",
        style: {
          float: 'left'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'pcty-input-wrapper' + cssMinMax
      }, /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
        className: "pcty-question-builder-constantsum-maximum",
        footnote: "Maximum value of each input field",
        formatter: function formatter(x) {
          if ((0, _isNotNullOrEmpty.default)(x) && parseInt(Math.floor(x)) > 0) {
            return x.toString();
          }
          return '';
        },
        id: "".concat(this.props.id, "-constantsum-maximum-").concat(this.state.edit.id.toString()),
        label: "Maximum Value",
        maxLength: 5,
        onChange: this.onChangeMaximumValue,
        placeholder: "Enter maximum value",
        value: this.state.edit.maximumValue
      }), showMinMaxError ? /*#__PURE__*/_react.default.createElement("span", {
        className: "pcty-input-footnote pcty-input-validation pcty-error pcty-margin-compact-top"
      }, this.state.validationState.minMax.errorMessage) : ''))));
    }
  }, {
    key: "getContent",
    value: function getContent() {
      var questionTypes = Object.keys(_questionBuilder.QUESTION_TYPE);
      var content;
      for (var typeIndex = 0; typeIndex < questionTypes.length; typeIndex++) {
        if (_questionBuilder.QUESTION_TYPE[questionTypes[typeIndex]] === this.state.edit.typeId) {
          content = this.renderDrawerQuestionContent[questionTypes[typeIndex]].render();
          break;
        }
      }
      return content;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.getContent());
    }
  }]);
  return PctyQuestionBuilderEditQuestion;
}(_react.Component);
PctyQuestionBuilderEditQuestion.propTypes = {
  id: _propTypes.default.string.isRequired,
  builderType: _propTypes.default.oneOf([_PctyQuestionBuilder.BUILDER_TYPE.quiz, _PctyQuestionBuilder.BUILDER_TYPE.survey]),
  edit: _propTypes.default.object,
  showValidationState: _propTypes.default.bool,
  validationState: _propTypes.default.object,
  includeScenario: _propTypes.default.bool,
  drawerType: _propTypes.default.oneOf(['question', 'title', 'paragraph', 'video']),
  onChange: _propTypes.default.func.isRequired,
  onGetSingleManageVideoToken: _propTypes.default.func.isRequired,
  number: _propTypes.default.number.isRequired,
  videoStudioEnabled: _propTypes.default.bool,
  questionCommentsEnabled: _propTypes.default.bool.isRequired
};
PctyQuestionBuilderEditQuestion.defaultProps = {
  showValidationState: false,
  includeScenario: true,
  drawerType: 'question',
  videoStudioEnabled: false,
  questionCommentsEnabled: false
};
var _default = exports.default = PctyQuestionBuilderEditQuestion;